import Axios from "../../../../api/axios/Axios";

export const getLatestHomePops = async ({
  limit = 10,
  offset = 0,
  signal,
} = {}) => {
  const response = await Axios.get("/api/home/pops", {
    params: {
      limit,
      offset,
    },
    signal,
  });

  return response.data;
};
